module.exports = __webpack_public_path__ + "static/img/gift-box-reward-back.5df3eee.png";